import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Backdrop, CircularProgress, Typography } from '@mui/material';
import { TranslationKeys } from 'app/translations';

type CompareBatchLoadingProps = {
  open: boolean;
};

export const CompareBatchLoading = ({ open }: CompareBatchLoadingProps) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: 999,
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        backdropFilter: 'blur(4px)',
        position: 'absolute',
        flexDirection: 'column',
        gap: 2,
      }}
      open={open}
    >
      <CircularProgress color="primary" size={60} />
      <Typography variant="h5" textAlign="center">
        <FormattedMessage id={TranslationKeys.connection_processes_compareBatch_synchronizingWithInsurer} />
      </Typography>
    </Backdrop>
  );
};
